"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACLProvider = ACLProvider;
exports.useACLState = useACLState;
exports.useACLDispatch = useACLDispatch;
exports.useACL = useACL;
exports.acl = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ACLStateContext = /*#__PURE__*/(0, _react.createContext)();
var ACLDispatchContext = /*#__PURE__*/(0, _react.createContext)();
function ACLProvider(_ref) {
  var children = _ref.children,
    user = _ref.user,
    aclRequests = _ref.aclRequests,
    _addACLRequest = _ref.addACLRequest,
    downloads = _ref.downloads,
    addDownload = _ref.addDownload,
    updateDownload = _ref.updateDownload,
    shares = _ref.shares,
    _shareProfile = _ref.shareProfile;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    onboardingDialogOpen = _useState2[0],
    setOnboardingDialogOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    onboardingError = _useState4[0],
    setOnboardingError = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    tokenMailSent = _useState6[0],
    setTokenMailSent = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    registrationComplete = _useState8[0],
    setRegistrationComplete = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    requestDialogOpen = _useState10[0],
    setRequestDialogOpen = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    requestPendingDialogOpen = _useState12[0],
    setRequestPendingDialogOpen = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    noAccessDialogOpen = _useState14[0],
    setNoAccessDialogOpen = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    certification = _useState16[0],
    setCertification = _useState16[1];
  var _useState17 = (0, _react.useState)(null),
    _useState18 = _slicedToArray(_useState17, 2),
    shareProfileDialogOpen = _useState18[0],
    setShareProfileDialogOpen = _useState18[1];
  var _useState19 = (0, _react.useState)(null),
    _useState20 = _slicedToArray(_useState19, 2),
    clbk = _useState20[0],
    setClbk = _useState20[1];
  var checkDownload = function checkDownload(_ref2, callback) {
    var certification = _ref2.certification,
      doc = _ref2.doc;
    console.log('checkDownload', {
      certification: certification,
      doc: doc,
      callback: callback
    });
    if (!user) {
      // show onboarding
      setOnboardingDialogOpen(true);
      return;
    }

    // was this doc downloaded before by this user?
    var userDownloads = Object.values(downloads).filter(function (_ref3) {
      var userId = _ref3.userId,
        certificationId = _ref3.certificationId;
      return userId === user._id && certificationId === certification._id;
    });
    var fileDownload = userDownloads.find(function (_ref4) {
      var document = _ref4.document;
      return document === doc;
    });
    if (fileDownload) {
      updateDownload(fileDownload);
      callback();
      return;
    }

    // no existing download of this file
    // check if user has shared his profile with unit
    var userShares = Object.values(shares).filter(function (_ref5) {
      var userId = _ref5.userId,
        unitId = _ref5.unitId;
      return userId === user._id && unitId === certification.unitId;
    });
    if (userShares && userShares.length > 0) {
      addDownload(certification, doc, user);
      callback();
      return;
    }
    setCertification(certification);
    setClbk(callback);
    setShareProfileDialogOpen(true);
  };
  var checkACL = function checkACL(_ref6, callback) {
    var certification = _ref6.certification,
      prop = _ref6.prop,
      acl = _ref6.acl;
    if (!acl[prop] || acl[prop] === 'PUBLIC') {
      return callback();
    }
    if (!user) {
      // show onboarding
      setOnboardingDialogOpen(true);
      return;
    }
    if (acl[prop] === 'REGISTERED') {
      return callback();
    }
    if (acl[prop] === 'PRIVATE') {
      // check if user has auth role for certification
      var unit = certification.unit();
      if (
      // all admins
      user.auth.includes('probeton') ||
      // if inspector for this cert
      // TODO: check if inspector for this certificate
      user.auth.includes('inspector') ||
      // user is representative for this unit
      unit.representatives && unit.representatives.includes(user._id)) {
        return callback();
      }
    }
    if (acl[prop] === 'ON_REQUEST') {
      var userRequests = Object.values(aclRequests).filter(function (_ref7) {
        var userId = _ref7.userId;
        return userId === user._id;
      });
      var currentRequest = userRequests.find(function (_ref8) {
        var certificationId = _ref8.certificationId;
        return certificationId === certification._id;
      });
      if (!userRequests || userRequests.length === 0 || !currentRequest) {
        // no existing request for user
        // let user create one
        setCertification(certification);
        setRequestDialogOpen(true);
        return;
      }
      if (!currentRequest.grants) {
        setRequestPendingDialogOpen(true);
        return;
      }
      if (currentRequest.grants && currentRequest.grants.granted) {
        return callback();
      }
    }
    setNoAccessDialogOpen(true);
  };
  var checkRegistered = function checkRegistered(callback) {
    if (!user) {
      // show onboarding
      setOnboardingDialogOpen(true);
      return;
    }
    return callback();
  };
  return /*#__PURE__*/_react["default"].createElement(ACLStateContext.Provider, {
    value: {
      onboardingDialogOpen: onboardingDialogOpen,
      onboardingError: onboardingError,
      registrationComplete: registrationComplete,
      tokenMailSent: tokenMailSent,
      requestDialogOpen: requestDialogOpen,
      requestPendingDialogOpen: requestPendingDialogOpen,
      noAccessDialogOpen: noAccessDialogOpen,
      checkACL: checkACL,
      checkDownload: checkDownload,
      checkRegistered: checkRegistered,
      clbk: clbk,
      shareProfileDialogOpen: shareProfileDialogOpen
    }
  }, /*#__PURE__*/_react["default"].createElement(ACLDispatchContext.Provider, {
    value: {
      setOnboardingDialogOpen: setOnboardingDialogOpen,
      setOnboardingError: setOnboardingError,
      setRegistrationComplete: setRegistrationComplete,
      setTokenMailSent: setTokenMailSent,
      setRequestDialogOpen: setRequestDialogOpen,
      setRequestPendingDialogOpen: setRequestPendingDialogOpen,
      setNoAccessDialogOpen: setNoAccessDialogOpen,
      checkACL: checkACL,
      checkDownload: checkDownload,
      checkRegistered: checkRegistered,
      setShareProfileDialogOpen: setShareProfileDialogOpen,
      addACLRequest: function addACLRequest() {
        _addACLRequest(certification, user);
      },
      shareProfile: function shareProfile() {
        console.log({
          certification: certification,
          user: user
        });
        _shareProfile(certification, user);
      }
    }
  }, children));
}
function useACLState() {
  var context = (0, _react.useContext)(ACLStateContext);
  if (context === undefined) {
    throw new Error('useACLState must be used within a ACLProvider');
  }
  return context;
}
function useACLDispatch() {
  var context = (0, _react.useContext)(ACLDispatchContext);
  if (context === undefined) {
    throw new Error('useACLDispatch must be used within a ACLProvider');
  }
  return context;
}
function useACL() {
  return [useACLState(), useACLDispatch()];
}
var acl = ['PUBLIC', 'REGISTERED', 'ON_REQUEST', 'PRIVATE'];
exports.acl = acl;